"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6536],{

/***/ 331256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ DownArrowIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);

var DownArrowIcon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: (props === null || props === void 0 ? void 0 : props.width) || "20px",
        height: (props === null || props === void 0 ? void 0 : props.height) || "20px",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                "clip-path": "url(#clip0_3665_9925)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M6.175 7.15839L10 10.9751L13.825 7.15839L15 8.33339L10 13.3334L5 8.33339L6.175 7.15839Z",
                    fill: props === null || props === void 0 ? void 0 : props.color
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_3665_9925",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: (props === null || props === void 0 ? void 0 : props.width) || "20px",
                        height: (props === null || props === void 0 ? void 0 : props.height) || "20px",
                        fill: props === null || props === void 0 ? void 0 : props.color,
                        transform: "translate(20) rotate(90)"
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 342383:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ RightArrowIconTransparent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);

var RightArrowIconTransparent = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: (props === null || props === void 0 ? void 0 : props.width) || "24px",
        height: (props === null || props === void 0 ? void 0 : props.width) || "24px",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                "clip-path": "url(#clip0_3272_805)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M8.59009 16.59L13.1701 12L8.59009 7.41L10.0001 6L16.0001 12L10.0001 18L8.59009 16.59Z",
                    fill: props === null || props === void 0 ? void 0 : props.color
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_3272_805",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: props === null || props === void 0 ? void 0 : props.color
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 78516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Button_Button; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(307297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(150066);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/CommonComponents/Button/Button.styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 6rem;\n  border-radius: ",
        "px;\n  outline: none;\n  border: none;\n  padding: 0.75rem 1rem;\n  cursor: pointer;\n  &.btn__primary {\n    background: ",
        ";\n    color: ",
        ";\n    font-size: ",
        "rem;\n    font-family: ",
        ";\n    font-weight: ",
        ";\n  }\n  &.btn__primary:hover {\n    background: ",
        ";\n    transition: background 0.5s ease-in-out;\n  }\n  &.btn__secondary {\n    background: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n    font-size: ",
        "rem;\n    font-family: ",
        ";\n    font-weight: ",
        ";\n  }\n  &.btn__secondary:hover {\n    background: ",
        ";\n    transition: background 0.5s ease-in-out;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ButtonComponent = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "ButtonComponent",
    componentId: "sc-7bbccc7b-0"
})(_templateObject(), function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.roundness) || 0;
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.backgroundColor;
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.color;
}, function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.textFontSize) || 1;
}, function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.fontFamily) || "Arial";
}, function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.fontWeight) || "500";
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.backgroundHoverColor;
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.secondaryButton) === null || ref === void 0 ? void 0 : ref.backgroundColor;
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.secondaryButton) === null || ref === void 0 ? void 0 : ref.borderColor;
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.secondaryButton) === null || ref === void 0 ? void 0 : ref.borderColor;
}, function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.secondaryButton) === null || ref === void 0 ? void 0 : ref.textFontSize) || 1;
}, function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.secondaryButton) === null || ref === void 0 ? void 0 : ref.fontFamily) || "Arial";
}, function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.secondaryButton) === null || ref === void 0 ? void 0 : ref.fontWeight) || "500";
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.secondaryButton) === null || ref === void 0 ? void 0 : ref.borderColor;
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.color;
});

// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/btnUtils.js
var btnUtils = __webpack_require__(993080);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/CommonComponents/Button/Button.js



var Button = function(props) {
    var ref, ref1, ref2;
    return (props === null || props === void 0 ? void 0 : (ref = props.btnData) === null || ref === void 0 ? void 0 : ref.btnText) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonComponent, {
        className: "btn__".concat(props === null || props === void 0 ? void 0 : (ref1 = props.btnData) === null || ref1 === void 0 ? void 0 : ref1.type),
        primaryButton: props === null || props === void 0 ? void 0 : props.primaryButton,
        secondaryButton: props === null || props === void 0 ? void 0 : props.secondaryButton,
        onClick: function() {
            var ref;
            (0,btnUtils/* btnActionHandler */.c)(props === null || props === void 0 ? void 0 : (ref = props.btnData) === null || ref === void 0 ? void 0 : ref.actions, props === null || props === void 0 ? void 0 : props.callback);
            (props === null || props === void 0 ? void 0 : props.handleClose) && (props === null || props === void 0 ? void 0 : props.handleClose());
        },
        children: props === null || props === void 0 ? void 0 : (ref2 = props.btnData) === null || ref2 === void 0 ? void 0 : ref2.btnText
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var Button_Button = (Button);


/***/ }),

/***/ 910502:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Dropdown_Dropdown; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./src/assets/svgExports/DownArrowIcon.js
var DownArrowIcon = __webpack_require__(331256);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(307297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(150066);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/common.js + 9 modules
var common = __webpack_require__(720901);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/CommonComponents/Dropdown/Dropdown.styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  display: flex;\n  width: 14.5rem;\n  flex-direction: column;\n  top: 32px;\n  z-index: 5;\n  max-height: 200px;\n  overflow-y: auto;\n\n  & div {\n    padding: 0.75rem 1rem;\n    text-align: left;\n    border-bottom: 1px solid\n      ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var DropwdownContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DropwdownContainer",
    componentId: "sc-a94810ad-0"
})(_templateObject(), function(props) {
    return (0,common/* hexToRgba */.a7)("".concat(props.themeConfig.borderColor), 0.1);
});

;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/CommonComponents/Dropdown/Dropdown.js



var Dropdown = function(param) {
    var dropDownData = param.dropDownData, handler = param.handler, rightPx = param.rightPx, logoSize = param.logoSize, themeConfig = param.themeConfig, handleClose = param.handleClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DropwdownContainer, {
        logoSize: logoSize,
        className: "dropdown-container",
        style: {
            right: rightPx || ""
        },
        themeConfig: themeConfig,
        children: dropDownData === null || dropDownData === void 0 ? void 0 : dropDownData.map(function(data) {
            var ref;
            return (data === null || data === void 0 ? void 0 : (ref = data.name) === null || ref === void 0 ? void 0 : ref.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                onClick: function() {
                    handler(data);
                    handleClose && handleClose();
                },
                style: {
                    justifyContent: rightPx ? "flex-end" : "flex-start",
                    textAlign: rightPx ? "right" : "left"
                },
                className: "nav-links",
                children: [
                    " ",
                    data === null || data === void 0 ? void 0 : data.name,
                    " ",
                    (data === null || data === void 0 ? void 0 : data.isDropdown) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DownArrowIcon/* DownArrowIcon */.G, {
                        color: "black"
                    }),
                    " "
                ]
            }, data === null || data === void 0 ? void 0 : data.id) : null;
        })
    });
};
/* harmony default export */ var Dropdown_Dropdown = (Dropdown);


/***/ }),

/***/ 876536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Header1_Header1; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./src/components/WidgetMaker/utils/common.ts
var common = __webpack_require__(737179);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/getStylesConfig.js
var getStylesConfig = __webpack_require__(842757);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/CommonComponents/Button/Button.js + 1 modules
var Button = __webpack_require__(78516);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/CommonComponents/Dropdown/Dropdown.js + 1 modules
var Dropdown = __webpack_require__(910502);
// EXTERNAL MODULE: ./src/assets/svgExports/DownArrowIcon.js
var DownArrowIcon = __webpack_require__(331256);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(307297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(150066);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/Header/Header1/component/HeaderDesktop.styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  @media screen and (min-width: 768px) {\n    padding: 1rem 2.5rem;\n    gap: 2.5rem;\n  }\n  @media screen and (max-width: 767px) {\n    padding: 0.75rem 1rem;\n    gap: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  display: flex;\n  justify-content: ",
        ";\n  gap: 1.5rem;\n\n  .nav-links {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    cursor: pointer;\n    position: relative;\n    font-size: 1rem;\n    font-family: ",
        ";\n    color: ",
        ";\n    font-weight: ",
        ";\n    font-family: ",
        ";\n  }\n  .nav-links:hover {\n    // padding-bottom: 0.5rem;\n    border-bottom: 1px solid ",
        ";\n  }\n\n  .nav-links svg path {\n    fill: currentColor;\n  }\n  & .dropdown-container {\n    background: ",
        ";\n    z-index: 100;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var HeaderDesktopContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "HeaderDesktopContainer",
    componentId: "sc-619ae0d8-0"
})(_templateObject());
var LogoContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "LogoContainer",
    componentId: "sc-619ae0d8-1"
})(_templateObject1(), function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.themeConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.color) || "#FFF";
});
var NavContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NavContainer",
    componentId: "sc-619ae0d8-2"
})(_templateObject2(), function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.styleConfig) === null || ref === void 0 ? void 0 : ref.horizontalAlign) || "flex-start";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.themeConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.fontFamily) || "Arial";
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.themeConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.fontWeight) || "500";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.themeConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.fontFamily) || "Arial";
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.themeConfig) === null || ref === void 0 ? void 0 : ref.backgroundColor) || "#fff";
});
var HeaderButtonContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "HeaderButtonContainer",
    componentId: "sc-619ae0d8-3"
})(_templateObject3());

// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/btnUtils.js
var btnUtils = __webpack_require__(993080);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/redux/actions/common.js
var actions_common = __webpack_require__(731024);
// EXTERNAL MODULE: ./src/redux/store/index.js + 45 modules
var store = __webpack_require__(17247);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/Header/Header1/component/HeaderDesktop.js











var HeaderDesktop = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var headerState = props.headerState, handleLogoClick = props.handleLogoClick;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref6 = (0,react.useState)({
        openDropDown: false,
        activeLink: ""
    }), dropDownActive = ref6[0], setDropDownActive = ref6[1];
    var dropdownRef = (0,react.useRef)(null);
    var parentLinkRef = (0,react.useRef)(null);
    var propStyle = (0,getStylesConfig/* getStyleForProps */.dn)(null);
    var handleNavInteraction = function(data) {
        if (data.actions.type === 5) {
            if (data.actions.handler === "") {
                setDropDownActive(function(prevState) {
                    return (prevState === null || prevState === void 0 ? void 0 : prevState.activeLink) === (data === null || data === void 0 ? void 0 : data.id) ? {
                        openDropDown: false,
                        activeLink: ""
                    } : {
                        openDropDown: true,
                        activeLink: data === null || data === void 0 ? void 0 : data.id
                    };
                });
            }
        } else if (data.actions.type === 2) {
            (0,btnUtils/* btnActionHandler */.c)(data === null || data === void 0 ? void 0 : data.actions, openForm);
            setDropDownActive({
                openDropDown: false,
                activeLink: ""
            });
        } else {
            (0,btnUtils/* btnActionHandler */.c)(data === null || data === void 0 ? void 0 : data.actions);
            setDropDownActive({
                openDropDown: false,
                activeLink: ""
            });
        }
    };
    var handleClickOutside = function(event) {
        if (parentLinkRef.current && !parentLinkRef.current.contains(event.target) && dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setDropDownActive({
                openDropDown: false,
                activeLink: ""
            });
        }
    };
    (0,react.useEffect)(function() {
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    var openForm = function() {
        dispatch((0,actions_common/* toggleFormWidget */.Aq)(true));
    };
    var storeName = (ref = store/* default.getState */.Z.getState().storeReducer.store) === null || ref === void 0 ? void 0 : ref.store_name;
    var getStoreLogo = function(storeLogoData) {
        var ref, ref1, ref2, ref3, ref4, ref5;
        return (storeLogoData === null || storeLogoData === void 0 ? void 0 : (ref = storeLogoData.content) === null || ref === void 0 ? void 0 : ref.store_logo_url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            className: "store_logo_image",
            src: storeLogoData === null || storeLogoData === void 0 ? void 0 : (ref1 = storeLogoData.content) === null || ref1 === void 0 ? void 0 : ref1.store_logo_url,
            alt: "store_logo",
            onError: function(e) {
                var ref;
                return e.target.src = storeLogoData === null || storeLogoData === void 0 ? void 0 : (ref = storeLogoData.content) === null || ref === void 0 ? void 0 : ref.store_logo_url;
            },
            width: (storeLogoData === null || storeLogoData === void 0 ? void 0 : (ref2 = storeLogoData.styleConfig) === null || ref2 === void 0 ? void 0 : ref2.width) ? "".concat(parseInt(storeLogoData === null || storeLogoData === void 0 ? void 0 : (ref3 = storeLogoData.styleConfig) === null || ref3 === void 0 ? void 0 : ref3.width) * 1, "px") : "0px",
            height: (storeLogoData === null || storeLogoData === void 0 ? void 0 : (ref4 = storeLogoData.styleConfig) === null || ref4 === void 0 ? void 0 : ref4.height) ? "".concat(parseInt(storeLogoData === null || storeLogoData === void 0 ? void 0 : (ref5 = storeLogoData.styleConfig) === null || ref5 === void 0 ? void 0 : ref5.height) * 1, "px") : "0px",
            style: {
                cursor: "pointer"
            },
            onClick: handleLogoClick
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: "store_logo_name",
            children: storeName
        });
    };
    var getHeaderButtons = function(storeButtonData) {
        return storeButtonData === null || storeButtonData === void 0 ? void 0 : storeButtonData.content.map(function(btnData, idx) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Button/* default */.Z, {
                btnData: btnData,
                primaryButton: propStyle === null || propStyle === void 0 ? void 0 : propStyle.buttonPrimary,
                secondaryButton: propStyle === null || propStyle === void 0 ? void 0 : propStyle.buttonSecondary,
                callback: openForm,
                handleClose: function() {
                    return setDropDownActive({
                        openDropDown: false,
                        activeLink: ""
                    });
                }
            }, (btnData === null || btnData === void 0 ? void 0 : btnData.id) || idx);
        });
    };
    var getHandler = function(data) {
        return handleNavInteraction(data);
    };
    var checkIfToBeApplied = function(navSpace) {
        if (navSpace === "flex-end") {
            return "-7px";
        }
    };
    var getNavLinks = function(navLinkData) {
        var ref;
        return navLinkData === null || navLinkData === void 0 ? void 0 : (ref = navLinkData.content) === null || ref === void 0 ? void 0 : ref.map(function(nav, idx) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
            return (nav === null || nav === void 0 ? void 0 : (ref = nav.name) === null || ref === void 0 ? void 0 : ref.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "nav-links",
                onClick: function() {
                    return getHandler(nav);
                },
                ref: parentLinkRef,
                children: [
                    nav === null || nav === void 0 ? void 0 : nav.name,
                    " ",
                    (nav === null || nav === void 0 ? void 0 : (ref1 = nav.actions) === null || ref1 === void 0 ? void 0 : ref1.type) === 5 && (nav === null || nav === void 0 ? void 0 : (ref2 = nav.children) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(DownArrowIcon/* DownArrowIcon */.G, {
                        color: "black"
                    }),
                    " ",
                    (nav === null || nav === void 0 ? void 0 : (ref3 = nav.actions) === null || ref3 === void 0 ? void 0 : ref3.type) === 5 && (dropDownActive === null || dropDownActive === void 0 ? void 0 : dropDownActive.activeLink) === (nav === null || nav === void 0 ? void 0 : nav.id) && (nav === null || nav === void 0 ? void 0 : (ref4 = nav.children) === null || ref4 === void 0 ? void 0 : ref4.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                        ref: dropdownRef,
                        dropDownData: nav === null || nav === void 0 ? void 0 : nav.children,
                        handler: getHandler,
                        width: "20px",
                        height: "20px",
                        rightPx: checkIfToBeApplied(navLinkData === null || navLinkData === void 0 ? void 0 : (ref5 = navLinkData.styleConfig) === null || ref5 === void 0 ? void 0 : ref5.horizontalAlign),
                        logoSize: headerState === null || headerState === void 0 ? void 0 : (ref6 = headerState.store_logo) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.styleConfig) === null || ref7 === void 0 ? void 0 : ref7.height,
                        themeConfig: propStyle
                    })
                ]
            }, nav === null || nav === void 0 ? void 0 : nav.id) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderDesktopContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoContainer, {
                themeConfig: propStyle,
                styleConfig: headerState === null || headerState === void 0 ? void 0 : headerState.styleConfig,
                children: ((headerState === null || headerState === void 0 ? void 0 : (ref1 = headerState.store_logo) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.content) === null || ref2 === void 0 ? void 0 : ref2.store_logo_url) || storeName) && getStoreLogo(headerState === null || headerState === void 0 ? void 0 : headerState.store_logo)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavContainer, {
                styleConfig: headerState === null || headerState === void 0 ? void 0 : (ref3 = headerState.nav_links) === null || ref3 === void 0 ? void 0 : ref3.styleConfig,
                themeConfig: propStyle,
                children: (headerState === null || headerState === void 0 ? void 0 : (ref4 = headerState.nav_links) === null || ref4 === void 0 ? void 0 : ref4.content) && getNavLinks(headerState === null || headerState === void 0 ? void 0 : headerState.nav_links)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderButtonContainer, {
                children: (headerState === null || headerState === void 0 ? void 0 : (ref5 = headerState.button) === null || ref5 === void 0 ? void 0 : ref5.content) && getHeaderButtons(headerState === null || headerState === void 0 ? void 0 : headerState.button)
            })
        ]
    });
};
/* harmony default export */ var component_HeaderDesktop = (HeaderDesktop);

// EXTERNAL MODULE: ./src/assets/svgExports/RightArrowIconTransparent.js
var RightArrowIconTransparent = __webpack_require__(342383);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/common.js + 9 modules
var utils_common = __webpack_require__(720901);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/Header/Header1/component/HeaderMobile.styled.js

function HeaderMobile_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0.75rem 1rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n"
    ]);
    HeaderMobile_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HeaderMobile_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: fit-content;\n  color: ",
        ";\n"
    ]);
    HeaderMobile_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HeaderMobile_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  flex-direction: column;\n  position: absolute;\n  width: 100%;\n  position: absolute;\n  width: 100%;\n  background: ",
        ";\n  top: ",
        "px;\n  z-index: 99999;\n  left: 0;\n  border-bottom: 1px solid\n    ",
        ";\n\n  &.main-container.activate-menu {\n    display: flex !important;\n  }\n"
    ]);
    HeaderMobile_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HeaderMobile_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding-left: 1rem;\n\n  .nav-links {\n    display: flex;\n    flex-direction: column;\n  }\n  .nav-links .links {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 1.5rem;\n    cursor: pointer;\n    font-size: 1rem;\n    color: ",
        ";\n    font-weight: ",
        ";\n    border-bottom: 1px solid\n      ",
        ";\n  }\n  .nav-links svg path {\n    fill: currentColor;\n  }\n  & .dropdown-container {\n    position: relative;\n    top: 0;\n    width: 100%;\n    color: ",
        ";\n  }\n  & .dropdown-container > .nav-links {\n    padding: 1.5rem 1.5rem 1.5rem 2.5rem;\n  }\n"
    ]);
    HeaderMobile_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  & > button {\n    width: 100% !important;\n    padding: 13px 12px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & .hamburger-menu {\n    display: flex;\n    flex-direction: column;\n    cursor: pointer;\n    transition: transform 0.3s ease-in-out;\n  }\n  & .bar1,\n  & .bar2,\n  & .bar3 {\n    width: 30px;\n    height: 2px;\n    background-color: ",
        ";\n    margin: 6px 0;\n    transition: transform 0.3s ease-in-out;\n  }\n  .activeBar1 {\n    transform: rotate(-45deg) translate(-5px, 6px) !important;\n  }\n\n  .activeBar2 {\n    opacity: 0;\n  }\n\n  .activeBar3 {\n    transform: rotate(45deg) translate(-5px, -6px) !important;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var HeaderMobileContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "HeaderMobileContainer",
    componentId: "sc-fa94750-0"
})(HeaderMobile_styled_templateObject());
var HeaderMobile_styled_LogoContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "LogoContainer",
    componentId: "sc-fa94750-1"
})(HeaderMobile_styled_templateObject1(), function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.color;
});
var MainContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "MainContainer",
    componentId: "sc-fa94750-2"
})(HeaderMobile_styled_templateObject2(), function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.themeConfig) === null || ref === void 0 ? void 0 : ref.backgroundColor) || "#fff";
}, function(props) {
    return ((props === null || props === void 0 ? void 0 : props.logoSize) ? parseInt(props === null || props === void 0 ? void 0 : props.logoSize) : 50) + 29;
}, function(props) {
    return (0,utils_common/* hexToRgba */.a7)("".concat(props.themeConfig.borderColor), 0.4);
});
var HeaderMobile_styled_NavContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NavContainer",
    componentId: "sc-fa94750-3"
})(HeaderMobile_styled_templateObject3(), function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.themeConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.fontWeight) || "500";
}, function(props) {
    return (0,utils_common/* hexToRgba */.a7)("".concat(props.themeConfig.borderColor), 0.1);
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.color;
});
var HeaderMobile_styled_HeaderButtonContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "HeaderButtonContainer",
    componentId: "sc-fa94750-4"
})(_templateObject4());
var HamburgerCoantianer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "HamburgerCoantianer",
    componentId: "sc-fa94750-5"
})(_templateObject5(), function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.themeConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.color) || "#000";
});

;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/Header/Header1/component/HeaderMobile.js












var HeaderMobile = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var headerState = props.headerState, handleLogoClick = props.handleLogoClick;
    var storeName = (ref = store/* default.getState */.Z.getState().storeReducer.store) === null || ref === void 0 ? void 0 : ref.store_name;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref7 = (0,react.useState)({
        openDropDown: false,
        activeLink: ""
    }), dropDownActive = ref7[0], setDropDownActive = ref7[1];
    var ref8 = (0,react.useState)(false), openNav = ref8[0], setOpenNav = ref8[1];
    var hamburgerRef = (0,react.useRef)(null);
    var hamburgerContainerRef = (0,react.useRef)(null);
    var dropdownRef = (0,react.useRef)(null);
    var parentLinkRef = (0,react.useRef)(null);
    var propStyle = (0,getStylesConfig/* getStyleForProps */.dn)(null);
    var openForm = function() {
        dispatch((0,actions_common/* toggleFormWidget */.Aq)(true));
    };
    var handleNavInteraction = function(data) {
        if (data.actions.type === 5) {
            if (data.actions.handler === "") {
                setDropDownActive(function(prevState) {
                    return (prevState === null || prevState === void 0 ? void 0 : prevState.activeLink) === (data === null || data === void 0 ? void 0 : data.id) ? {
                        openDropDown: false,
                        activeLink: ""
                    } : {
                        openDropDown: true,
                        activeLink: data === null || data === void 0 ? void 0 : data.id
                    };
                });
            }
        } else if (data.actions.type === 2) {
            (0,btnUtils/* btnActionHandler */.c)(data === null || data === void 0 ? void 0 : data.actions, openForm);
            setOpenNav(false);
        } else {
            (0,btnUtils/* btnActionHandler */.c)(data === null || data === void 0 ? void 0 : data.actions);
            setOpenNav(false);
        }
    };
    var getHandler = function(data) {
        return handleNavInteraction(data);
    };
    var handleClickOutsideHamburger = function(e) {
        if (hamburgerRef.current && !hamburgerRef.current.contains(e.target) && hamburgerContainerRef.current && !hamburgerContainerRef.current.contains(e.target)) {
            setOpenNav(false);
        }
    };
    (0,react.useEffect)(function() {
        document.addEventListener("mousedown", handleClickOutsideHamburger);
        return function() {
            document.removeEventListener("mousedown", handleClickOutsideHamburger);
        };
    }, []);
    var handleClickOutside = function(event) {
        if (parentLinkRef.current && !parentLinkRef.current.contains(event.target)) {
            setDropDownActive({
                openDropDown: false,
                activeLink: ""
            });
        }
    };
    (0,react.useEffect)(function() {
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    var getStoreLogo = function(storeLogoData) {
        var ref, ref1, ref2, ref3, ref4, ref5;
        return (storeLogoData === null || storeLogoData === void 0 ? void 0 : (ref = storeLogoData.content) === null || ref === void 0 ? void 0 : ref.store_logo_url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            className: "store_logo_image",
            src: storeLogoData === null || storeLogoData === void 0 ? void 0 : (ref1 = storeLogoData.content) === null || ref1 === void 0 ? void 0 : ref1.store_logo_url,
            alt: "store_logo",
            width: (storeLogoData === null || storeLogoData === void 0 ? void 0 : (ref2 = storeLogoData.styleConfig) === null || ref2 === void 0 ? void 0 : ref2.width) ? "".concat(parseInt(storeLogoData === null || storeLogoData === void 0 ? void 0 : (ref3 = storeLogoData.styleConfig) === null || ref3 === void 0 ? void 0 : ref3.width) * 1, "px") : "0px",
            height: (storeLogoData === null || storeLogoData === void 0 ? void 0 : (ref4 = storeLogoData.styleConfig) === null || ref4 === void 0 ? void 0 : ref4.height) ? "".concat(parseInt(storeLogoData === null || storeLogoData === void 0 ? void 0 : (ref5 = storeLogoData.styleConfig) === null || ref5 === void 0 ? void 0 : ref5.width) * 1, "px") : "0px",
            onError: function(e) {
                var ref;
                return e.target.src = storeLogoData === null || storeLogoData === void 0 ? void 0 : (ref = storeLogoData.content) === null || ref === void 0 ? void 0 : ref.store_logo_url;
            },
            style: {
                cursor: "pointer"
            },
            onClick: handleLogoClick
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: "store_logo_name",
            children: storeName
        });
    };
    var getHeaderButtons = function(storeButtonData) {
        return storeButtonData === null || storeButtonData === void 0 ? void 0 : storeButtonData.content.map(function(btnData, idx) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Button/* default */.Z, {
                btnData: btnData,
                primaryButton: propStyle === null || propStyle === void 0 ? void 0 : propStyle.buttonPrimary,
                secondaryButton: propStyle === null || propStyle === void 0 ? void 0 : propStyle.buttonSecondary,
                callback: openForm,
                handleClose: function() {
                    return setOpenNav(false);
                }
            }, (btnData === null || btnData === void 0 ? void 0 : btnData.id) || idx);
        });
    };
    var getNavLinks = function(navLinkData) {
        var ref;
        return navLinkData === null || navLinkData === void 0 ? void 0 : (ref = navLinkData.content) === null || ref === void 0 ? void 0 : ref.map(function(nav) {
            var ref, ref1, ref2, ref3, ref4;
            return (nav === null || nav === void 0 ? void 0 : (ref = nav.name) === null || ref === void 0 ? void 0 : ref.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "nav-links",
                onClick: function() {
                    getHandler(nav);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "links",
                        children: [
                            " ",
                            nav === null || nav === void 0 ? void 0 : nav.name,
                            " ",
                            (nav === null || nav === void 0 ? void 0 : (ref1 = nav.actions) === null || ref1 === void 0 ? void 0 : ref1.type) === 5 && (nav === null || nav === void 0 ? void 0 : (ref2 = nav.children) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && ((dropDownActive === null || dropDownActive === void 0 ? void 0 : dropDownActive.activeLink) === (nav === null || nav === void 0 ? void 0 : nav.id) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DownArrowIcon/* DownArrowIcon */.G, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(RightArrowIconTransparent/* RightArrowIconTransparent */.I, {
                                color: "black"
                            })),
                            " "
                        ]
                    }),
                    (nav === null || nav === void 0 ? void 0 : (ref3 = nav.actions) === null || ref3 === void 0 ? void 0 : ref3.type) === 5 && (dropDownActive === null || dropDownActive === void 0 ? void 0 : dropDownActive.activeLink) === (nav === null || nav === void 0 ? void 0 : nav.id) && (nav === null || nav === void 0 ? void 0 : (ref4 = nav.children) === null || ref4 === void 0 ? void 0 : ref4.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                        className: "".concat(dropDownActive === null || dropDownActive === void 0 ? void 0 : dropDownActive.openDropDown),
                        ref: dropdownRef,
                        dropDownData: nav === null || nav === void 0 ? void 0 : nav.children,
                        handler: getHandler,
                        width: "24px",
                        height: "24px",
                        themeConfig: propStyle
                    }) : null
                ]
            }, nav === null || nav === void 0 ? void 0 : nav.id) : null;
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderMobileContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMobile_styled_LogoContainer, {
                themeConfig: propStyle,
                styleConfig: headerState === null || headerState === void 0 ? void 0 : headerState.styleConfig,
                children: ((headerState === null || headerState === void 0 ? void 0 : (ref1 = headerState.store_logo) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.content) === null || ref2 === void 0 ? void 0 : ref2.store_logo_url) || storeName) && getStoreLogo(headerState === null || headerState === void 0 ? void 0 : headerState.store_logo)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HamburgerCoantianer, {
                themeConfig: propStyle,
                ref: hamburgerRef,
                className: "hamburger-menu ".concat(openNav ? "open" : ""),
                onClick: function() {
                    setOpenNav(!openNav);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bar1 ".concat(openNav ? "activeBar1" : "")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bar2 ".concat(openNav ? "activeBar2" : "")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bar3 ".concat(openNav ? "activeBar3" : "")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainContainer, {
                themeConfig: propStyle,
                styleConfig: headerState === null || headerState === void 0 ? void 0 : headerState.styleConfig,
                logoSize: headerState === null || headerState === void 0 ? void 0 : (ref3 = headerState.store_logo) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.styleConfig) === null || ref4 === void 0 ? void 0 : ref4.height,
                className: " main-container ".concat(openNav ? "activate-menu" : ""),
                ref: hamburgerContainerRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMobile_styled_NavContainer, {
                        themeConfig: propStyle,
                        ref: parentLinkRef,
                        children: (headerState === null || headerState === void 0 ? void 0 : (ref5 = headerState.nav_links) === null || ref5 === void 0 ? void 0 : ref5.content) && getNavLinks(headerState === null || headerState === void 0 ? void 0 : headerState.nav_links)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMobile_styled_HeaderButtonContainer, {
                        children: (headerState === null || headerState === void 0 ? void 0 : (ref6 = headerState.button) === null || ref6 === void 0 ? void 0 : ref6.content) && getHeaderButtons(headerState === null || headerState === void 0 ? void 0 : headerState.button)
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var component_HeaderMobile = (HeaderMobile);

;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/Header/Header1/Header1.styled.js

function Header1_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  background: ",
        ";\n  border-bottom: 1px solid\n    ",
        ";\n"
    ]);
    Header1_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var HeaderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "HeaderContainer",
    componentId: "sc-fd4f07a9-0"
})(Header1_styled_templateObject(), function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.themeConfig) === null || ref === void 0 ? void 0 : ref.backgroundColor) || "#fff";
}, function(props) {
    var ref;
    return (0,utils_common/* hexToRgba */.a7)("".concat(props === null || props === void 0 ? void 0 : (ref = props.themeConfig) === null || ref === void 0 ? void 0 : ref.borderColor), 0.1);
});

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(811163);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(326706);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/Header/Header1/Header1.js











var Header1 = function(props) {
    var ref, ref1, ref2, ref3;
    var ref4 = (0,react.useState)((0,common/* transformWidgetProps */.Ak)(props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : ref.children)), headerState = ref4[0], setHeaderState = ref4[1];
    var ref5 = (0,react.useState)(false), IS_DESKTOP = ref5[0], setIS_DESKTOP = ref5[1];
    var checkWindowSize = function() {
        if (true) {
            var isMobile = window.innerWidth < 768; // You can adjust this threshold
            setIS_DESKTOP(!isMobile);
        }
    };
    (0,react.useEffect)(function() {
        // Check window size on component mount
        checkWindowSize();
        // Add event listener for window resize only on the client side
        var handleResize = function() {
            checkWindowSize();
        };
        if (true) {
            window.addEventListener("resize", handleResize);
            // Cleanup the event listener on component unmount
            return function() {
                window.removeEventListener("resize", handleResize);
            };
        }
    }, []);
    (0,react.useEffect)(function() {
        var ref;
        setHeaderState((0,common/* transformWidgetProps */.Ak)(props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : ref.children));
    }, [
        props
    ]);
    var storeData = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    var widgetData = (0,es/* useSelector */.v9)(function(state) {
        return {
            widgetData: state.widgetsReducer
        };
    }).widgetData;
    var ref6 = (0,react.useState)(storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.theme) === null || ref1 === void 0 ? void 0 : ref1.style_template), propStyle = ref6[0], setPropStyle = ref6[1];
    (0,react.useEffect)(function() {
        if (widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate) {
            setPropStyle((0,getStylesConfig/* getStyleForProps */.dn)(widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate));
        } else {
            var ref;
            setPropStyle((0,getStylesConfig/* getStyleForProps */.dn)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.style_template));
        }
    }, [
        widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate,
        storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.theme) === null || ref2 === void 0 ? void 0 : ref2.style_template
    ]);
    var router = (0,next_router.useRouter)();
    var handleLogoClick = function() {
        var ref;
        return router.push((0,routes.getRoute)(routes.PATH.PRODUCT, storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderContainer, {
        id: "Header",
        styleConfig: propStyle,
        propsBackground: headerState === null || headerState === void 0 ? void 0 : (ref3 = headerState.media) === null || ref3 === void 0 ? void 0 : ref3.background,
        themeConfig: propStyle,
        children: IS_DESKTOP ? /*#__PURE__*/ (0,jsx_runtime.jsx)(component_HeaderDesktop, {
            headerState: headerState,
            setHeaderState: setHeaderState,
            handleLogoClick: handleLogoClick
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(component_HeaderMobile, {
            headerState: headerState,
            setHeaderState: setHeaderState,
            handleLogoClick: handleLogoClick
        })
    });
};
/* harmony default export */ var Header1_Header1 = (Header1);


/***/ })

}]);